import { useMemo } from 'react'

import { CompanyDocumentsTab } from './CompanyDocumentsTab'
import { TeamMemberFormsTab } from './TeamMemberFormsTab'
import { Alert, Card, CardColors, Link, Tab, Text } from '@/ui'
import { TypographyStyles } from '@/styles'

export const PayrollDocuments = () => {
  const panes = useMemo(
    () => [
      {
        menuItem: 'Company Forms',
        render: () => <CompanyDocumentsTab />,
      },
      {
        menuItem: 'Team Member Forms',
        render: () => <TeamMemberFormsTab />,
      },
    ],
    []
  )

  return (
    <Card color={CardColors.LEVEL_0}>
      <Text variant={TypographyStyles.H1}>Payroll Documents</Text>
      <br />
      <Alert>
        <Text variant={TypographyStyles.BODY_MD}>
          This page only lists Documents related to Payroll.
        </Text>
        <Text variant={TypographyStyles.BODY_MD}>
          Looking for other Heard Documents?{' '}
          <Link href="/practice/documents">
            Head to the regular Documents Page
          </Link>
        </Text>
      </Alert>
      <br />
      <Tab panes={panes} />
    </Card>
  )
}
